import React, { createContext } from 'react';
import { InfoText } from 'Types/AppSettings';

export const AppSettingsContext = createContext({
  infoTexts: [] as InfoText[],
  setInfoTexts: (infoTexts: InfoText[]) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars
  getInfoText: (key: string): InfoText | undefined => ({
    key,
    name: 'name',
    description: 'description',
  }),
});

interface Props {
  children: React.ReactNode;
}

export const AppSettingsProvider = ({ children }: Props) => {
  const [infoTexts, setInfoTexts] = React.useState<InfoText[]>([]);

  const getInfoText = (key: string): InfoText | undefined => {
    if (infoTexts?.length) {
      const info = infoTexts.find((it) => it.key === key);
      if (info) {
        return info;
      }
    }
    return undefined;
  };

  return (
    <AppSettingsContext.Provider
      value={{ infoTexts, setInfoTexts, getInfoText }}
    >
      {children}
    </AppSettingsContext.Provider>
  );
};
